module.exports = __webpack_public_path__ + "img/cs1.f7fd1cb7.jpg";